import React from 'react';
import './StepNavigation.css';

function StepNavigation({
  currentStep,
  totalSteps = 6,
  onNext,
  onBack,
  onSkip,
  canProceed = true,
  loading = false,
  isLastStep = false,
  showSkip = false,
}) {
  const isFirstStep = currentStep === 1;

  return (
    <div className="step-navigation">
      <div className="nav-left">
        {!isFirstStep && (
          <button
            type="button"
            className="nav-button secondary"
            onClick={onBack}
            disabled={loading}
          >
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M10 12L6 8L10 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            Back
          </button>
        )}
      </div>

      <div className="nav-center">
        {showSkip && currentStep > 2 && (
          <button
            type="button"
            className="nav-button skip"
            onClick={onSkip}
            disabled={loading}
          >
            Skip to Dashboard
          </button>
        )}
      </div>

      <div className="nav-right">
        <button
          type="button"
          className={`nav-button primary ${isLastStep ? 'finish' : ''}`}
          onClick={onNext}
          disabled={!canProceed || loading}
        >
          {loading ? (
            <>
              <span className="spinner" />
              Saving...
            </>
          ) : isLastStep ? (
            <>
              Complete Setup
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M13.5 4.5L6 12L2.5 8.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </>
          ) : (
            <>
              Continue
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M6 12L10 8L6 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </>
          )}
        </button>
      </div>
    </div>
  );
}

export default StepNavigation;
